// extracted by mini-css-extract-plugin
var _1 = "mBWkI__betId";
var _2 = "mBWkI__center";
var _3 = "mBWkI__entries";
var _4 = "mBWkI__gameLink";
var _5 = "mBWkI__head";
var _6 = "mBWkI__slide1";
var _7 = "mBWkI__slide2";
var _8 = "mBWkI__slideIn";
var _9 = "mBWkI__table";
var _a = "mBWkI__userButton";
export { _1 as "betId", _2 as "center", _3 as "entries", _4 as "gameLink", _5 as "head", _6 as "slide1", _7 as "slide2", _8 as "slideIn", _9 as "table", _a as "userButton" }
